import React, { useState, useEffect, useRef } from 'react';

const FEATURES = [
  { icon: 'monitor', title: 'PDV Completo', desc: 'Frente de caixa moderna com venda rápida, mesas, comandas e controle de salão integrado.', color: '#FF6B35' },
  { icon: 'layout', title: 'Kanban de Pedidos', desc: 'Gestão visual de todos os pedidos em tempo real — da cozinha à entrega.', color: '#F7C948' },
  { icon: 'smartphone', title: 'Cardápio Digital', desc: 'QR Code para clientes fazerem pedidos direto do celular, sem app.', color: '#4ECDC4' },
  { icon: 'truck', title: 'Gestão de Entregas', desc: 'Controle de motoboys, rotas, taxas por região e rastreamento do pedido.', color: '#FF6B35' },
  { icon: 'bot', title: 'WhatsApp com IA', desc: 'Chatbot inteligente que atende, tira dúvidas e envia cardápio automaticamente.', color: '#25D366' },
  { icon: 'handshake', title: 'Handoff Humano', desc: 'Detecção automática de intervenção humana — o robô pausa quando o atendente assume.', color: '#6C5CE7' },
  { icon: 'printer', title: 'Impressão Térmica', desc: 'Impressão automática de cupons ESC/POS direto na cozinha e no caixa.', color: '#E17055' },
  { icon: 'bar-chart', title: 'Dashboard & Analytics', desc: 'Relatórios de vendas, faturamento, ticket médio, heatmap e métricas em tempo real.', color: '#0984E3' },
  { icon: 'users', title: 'CRM de Clientes', desc: 'Base de clientes com histórico de pedidos, preferências e segmentação.', color: '#FDCB6E' },
  { icon: 'package', title: 'Controle de Estoque', desc: 'Gestão de insumos, alertas de estoque mínimo e custos por produto.', color: '#00B894' },
  { icon: 'receipt', title: 'Módulo Fiscal', desc: 'Emissão de NFC-e/NF-e integrada com SEFAZ. Compliance fiscal completo.', color: '#636E72' },
  { icon: 'shield', title: 'RBAC & Segurança', desc: 'Controle de acesso por perfil — caixa, gerente, cozinha, entregador.', color: '#D63031' },
];

const INTEGRATIONS = [
  { name: 'iFood', color: '#EA1D2C', desc: 'Homologada', logo: 'ifood' },
  { name: 'Keeta', color: '#FF6600', desc: 'Homologada', logo: 'keeta' },
  { name: '99Food', color: '#FFCB05', desc: 'Homologada', logo: '99food' },
  { name: 'WhatsApp', color: '#25D366', desc: 'Evolution API', logo: 'whatsapp' },
  { name: 'ChatGPT', color: '#10A37F', desc: 'IA Integrada', logo: 'openai' },
  { name: 'SEFAZ', color: '#003366', desc: 'NFC-e / NF-e', logo: 'sefaz' },
];

const STATS = [
  { value: '42k+', label: 'Mensagens processadas' },
  { value: '1.500+', label: 'Clientes atendidos' },
  { value: '3', label: 'Marketplaces homologados' },
  { value: '24/7', label: 'Atendimento IA' },
];

const Icons = {
  monitor: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
  ),
  layout: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
  ),
  smartphone: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
  ),
  truck: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
  ),
  bot: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" y1="16" x2="8" y2="16"/><line x1="16" y1="16" x2="16" y2="16"/></svg>
  ),
  handshake: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"/></svg>
  ),
  printer: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
  ),
  'bar-chart': (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>
  ),
  users: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  ),
  package: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
  ),
  receipt: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 17.5v-11"/></svg>
  ),
  shield: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
  ),
  check: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
  ),
  arrow: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
  ),
  menu: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
  ),
  x: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
  ),
};

const IntegrationLogo = ({ type, size = 40 }) => {
  const logos = {
    ifood: (
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#EA1D2C"/>
        <text x="50" y="58" textAnchor="middle" fill="white" fontWeight="bold" fontSize="22" fontFamily="sans-serif">iFood</text>
      </svg>
    ),
    keeta: (
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#FF6600"/>
        <text x="50" y="58" textAnchor="middle" fill="white" fontWeight="bold" fontSize="20" fontFamily="sans-serif">Keeta</text>
      </svg>
    ),
    '99food': (
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#FFCB05"/>
        <text x="50" y="58" textAnchor="middle" fill="#333" fontWeight="bold" fontSize="18" fontFamily="sans-serif">99Food</text>
      </svg>
    ),
    whatsapp: (
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#25D366"/>
        <text x="50" y="58" textAnchor="middle" fill="white" fontWeight="bold" fontSize="16" fontFamily="sans-serif">WhatsApp</text>
      </svg>
    ),
    openai: (
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#10A37F"/>
        <text x="50" y="56" textAnchor="middle" fill="white" fontWeight="bold" fontSize="16" fontFamily="sans-serif">ChatGPT</text>
      </svg>
    ),
    sefaz: (
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="#003366"/>
        <text x="50" y="56" textAnchor="middle" fill="white" fontWeight="bold" fontSize="18" fontFamily="sans-serif">SEFAZ</text>
      </svg>
    ),
  };
  return logos[type] || null;
};

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

function AnimatedSection({ children, className = '', delay = 0 }) {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(40px)',
        transition: `all 0.7s cubic-bezier(0.16, 1, 0.3, 1) ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

export default function LandingPage() {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenu(false);
  };

  return (
    <div data-testid="landing-page" style={{ background: '#0A0A0F', color: '#E8E8ED', minHeight: '100vh', fontFamily: "'Inter', -apple-system, sans-serif", overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::selection { background: #FF6B35; color: #fff; }
        .lp-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; transition: all .3s; }
        .lp-nav.scrolled { background: rgba(10,10,15,.92); backdrop-filter: blur(20px); border-bottom: 1px solid rgba(255,107,53,.1); }
        .lp-container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
        .lp-btn { display: inline-flex; align-items: center; gap: 8px; padding: 14px 32px; border-radius: 100px; font-weight: 600; font-size: 15px; border: none; cursor: pointer; transition: all .3s; text-decoration: none; }
        .lp-btn-primary { background: linear-gradient(135deg, #FF6B35, #E8532E); color: #fff; }
        .lp-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(255,107,53,.35); }
        .lp-btn-outline { background: transparent; color: #FF6B35; border: 1.5px solid rgba(255,107,53,.4); }
        .lp-btn-outline:hover { background: rgba(255,107,53,.08); border-color: #FF6B35; }
        .lp-hero { padding: 160px 0 100px; position: relative; overflow: hidden; }
        .lp-hero::before { content: ''; position: absolute; top: -200px; right: -200px; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(255,107,53,.12) 0%, transparent 70%); pointer-events: none; }
        .lp-hero::after { content: ''; position: absolute; bottom: -100px; left: -100px; width: 400px; height: 400px; border-radius: 50%; background: radial-gradient(circle, rgba(78,205,196,.08) 0%, transparent 70%); pointer-events: none; }
        .lp-tag { display: inline-flex; align-items: center; gap: 8px; padding: 6px 16px; border-radius: 100px; background: rgba(255,107,53,.1); border: 1px solid rgba(255,107,53,.2); color: #FF6B35; font-size: 13px; font-weight: 600; letter-spacing: .5px; text-transform: uppercase; margin-bottom: 24px; }
        .lp-tag .dot { width: 6px; height: 6px; border-radius: 50%; background: #FF6B35; animation: pulse 2s infinite; }
        @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: .4; } }
        .lp-h1 { font-size: clamp(36px, 5.5vw, 68px); font-weight: 800; line-height: 1.08; letter-spacing: -2px; margin-bottom: 24px; }
        .lp-h1 .accent { background: linear-gradient(135deg, #FF6B35, #F7C948); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .lp-subtitle { font-size: clamp(16px, 2vw, 20px); color: #9B9BA7; line-height: 1.7; max-width: 560px; margin-bottom: 40px; font-weight: 400; }
        .lp-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 2px; background: rgba(255,255,255,.04); border-radius: 20px; overflow: hidden; border: 1px solid rgba(255,255,255,.06); }
        .lp-stat { padding: 40px 24px; text-align: center; background: rgba(10,10,15,.6); backdrop-filter: blur(10px); }
        .lp-stat-val { font-size: 36px; font-weight: 800; background: linear-gradient(135deg, #FF6B35, #F7C948); -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin-bottom: 4px; }
        .lp-stat-label { font-size: 13px; color: #7B7B8A; font-weight: 500; }
        .lp-section { padding: 100px 0; }
        .lp-section-title { text-align: center; margin-bottom: 64px; }
        .lp-h2 { font-size: clamp(28px, 3.5vw, 44px); font-weight: 800; letter-spacing: -1.5px; margin-bottom: 16px; }
        .lp-section-sub { font-size: 17px; color: #7B7B8A; max-width: 600px; margin: 0 auto; line-height: 1.6; }
        .lp-features { display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: 20px; }
        .lp-feature { padding: 32px; border-radius: 16px; background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.06); transition: all .4s; position: relative; overflow: hidden; }
        .lp-feature:hover { background: rgba(255,255,255,.06); border-color: rgba(255,107,53,.2); transform: translateY(-4px); }
        .lp-feature-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px; }
        .lp-feature h3 { font-size: 18px; font-weight: 700; margin-bottom: 8px; color: #F0F0F5; }
        .lp-feature p { font-size: 14px; color: #8B8B9A; line-height: 1.6; }
        .lp-integrations { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 20px; max-width: 800px; margin: 0 auto; }
        .lp-integration { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 32px 16px; border-radius: 16px; background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.06); transition: all .4s; }
        .lp-integration:hover { background: rgba(255,255,255,.06); transform: translateY(-4px); }
        .lp-integration-name { font-weight: 700; font-size: 16px; }
        .lp-integration-badge { font-size: 11px; padding: 4px 12px; border-radius: 100px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; }
        .lp-cta { text-align: center; padding: 100px 24px; position: relative; }
        .lp-cta::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse at center, rgba(255,107,53,.08) 0%, transparent 60%); pointer-events: none; }
        .lp-footer { border-top: 1px solid rgba(255,255,255,.06); padding: 40px 0; text-align: center; color: #5B5B6A; font-size: 14px; }
        .lp-mobile-menu { position: fixed; inset: 0; z-index: 200; background: rgba(10,10,15,.98); backdrop-filter: blur(20px); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 32px; }
        .lp-mobile-menu a { font-size: 22px; font-weight: 600; color: #E8E8ED; cursor: pointer; text-decoration: none; }
        .lp-mobile-close { position: absolute; top: 24px; right: 24px; background: none; border: none; color: #E8E8ED; cursor: pointer; }
        .lp-workflow { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 24px; max-width: 1000px; margin: 0 auto; }
        .lp-workflow-step { text-align: center; padding: 32px 20px; border-radius: 16px; background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.06); position: relative; }
        .lp-workflow-num { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 20px; margin: 0 auto 16px; }
        .lp-workflow-step h3 { font-size: 16px; font-weight: 700; margin-bottom: 8px; }
        .lp-workflow-step p { font-size: 13px; color: #8B8B9A; line-height: 1.5; }
        .lp-nav-links { display: flex; align-items: center; gap: 32px; }
        .lp-nav-link { color: #9B9BA7; font-size: 14px; font-weight: 500; cursor: pointer; transition: color .2s; text-decoration: none; background: none; border: none; }
        .lp-nav-link:hover { color: #FF6B35; }
        .lp-hamburger { display: none; background: none; border: none; color: #E8E8ED; cursor: pointer; }
        @media (max-width: 768px) {
          .lp-nav-links { display: none; }
          .lp-hamburger { display: block; }
          .lp-features { grid-template-columns: 1fr; }
          .lp-stats { grid-template-columns: repeat(2, 1fr); }
          .lp-integrations { grid-template-columns: repeat(2, 1fr); }
          .lp-hero { padding: 120px 0 60px; }
          .lp-section { padding: 60px 0; }
        }
        @media (max-width: 480px) {
          .lp-stats { grid-template-columns: 1fr; }
          .lp-integrations { grid-template-columns: 1fr; }
        }
      `}</style>

      {/* NAV */}
      <nav className={`lp-nav ${scrolled ? 'scrolled' : ''}`} data-testid="landing-nav">
        <div className="lp-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={() => scrollTo('hero')}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #FF6B35, #E8532E)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 18, color: '#fff' }}>V</div>
            <span style={{ fontWeight: 700, fontSize: 18, color: '#F0F0F5', letterSpacing: '-0.5px' }}>Hit Grill System</span>
          </div>
          <div className="lp-nav-links">
            <button className="lp-nav-link" onClick={() => scrollTo('features')}>Funcionalidades</button>
            <button className="lp-nav-link" onClick={() => scrollTo('integrations')}>Integrações</button>
            <button className="lp-nav-link" onClick={() => scrollTo('workflow')}>Como Funciona</button>
            <button className="lp-btn lp-btn-primary" style={{ padding: '10px 24px', fontSize: 13 }} onClick={() => scrollTo('cta')}>Fale Conosco</button>
          </div>
          <button className="lp-hamburger" onClick={() => setMobileMenu(true)} aria-label="Menu">{Icons.menu}</button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      {mobileMenu && (
        <div className="lp-mobile-menu">
          <button className="lp-mobile-close" onClick={() => setMobileMenu(false)}>{Icons.x}</button>
          <a onClick={() => scrollTo('features')}>Funcionalidades</a>
          <a onClick={() => scrollTo('integrations')}>Integrações</a>
          <a onClick={() => scrollTo('workflow')}>Como Funciona</a>
          <a onClick={() => scrollTo('cta')}>Fale Conosco</a>
        </div>
      )}

      {/* HERO */}
      <section className="lp-hero" id="hero">
        <div className="lp-container">
          <AnimatedSection>
            <div className="lp-tag"><span className="dot" /> Sistema Homologado</div>
          </AnimatedSection>
          <AnimatedSection delay={0.1}>
            <h1 className="lp-h1">
              O sistema completo<br />para <span className="accent">seu restaurante</span>
            </h1>
          </AnimatedSection>
          <AnimatedSection delay={0.2}>
            <p className="lp-subtitle">
              PDV, delivery, cardápio digital, WhatsApp com IA e integração homologada com iFood, Keeta e 99Food. Tudo em uma única plataforma.
            </p>
          </AnimatedSection>
          <AnimatedSection delay={0.3}>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <button className="lp-btn lp-btn-primary" onClick={() => scrollTo('cta')} data-testid="hero-cta-btn">
                Quero para meu restaurante {Icons.arrow}
              </button>
              <button className="lp-btn lp-btn-outline" onClick={() => scrollTo('features')} data-testid="hero-features-btn">
                Ver funcionalidades
              </button>
            </div>
          </AnimatedSection>

          {/* BADGE MARKETPLACES */}
          <AnimatedSection delay={0.4}>
            <div style={{ display: 'flex', gap: 12, marginTop: 48, flexWrap: 'wrap', alignItems: 'center' }}>
              {['iFood', 'Keeta', '99Food'].map(name => (
                <div key={name} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px', borderRadius: 100, background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.08)' }}>
                  <span style={{ color: '#4ECDC4' }}>{Icons.check}</span>
                  <span style={{ fontSize: 13, fontWeight: 600 }}>Homologado {name}</span>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* STATS */}
      <section style={{ padding: '0 0 80px' }}>
        <div className="lp-container">
          <AnimatedSection>
            <div className="lp-stats" data-testid="landing-stats">
              {STATS.map((s, i) => (
                <div key={i} className="lp-stat">
                  <div className="lp-stat-val">{s.value}</div>
                  <div className="lp-stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* FEATURES */}
      <section className="lp-section" id="features" style={{ background: 'rgba(255,255,255,.01)' }}>
        <div className="lp-container">
          <div className="lp-section-title">
            <AnimatedSection>
              <div className="lp-tag" style={{ justifyContent: 'center' }}>12+ Módulos</div>
              <h2 className="lp-h2">Tudo que seu restaurante <span style={{ color: '#FF6B35' }}>precisa</span></h2>
              <p className="lp-section-sub">Do pedido à entrega, do caixa ao fiscal. Um ecossistema completo para operação e crescimento.</p>
            </AnimatedSection>
          </div>
          <div className="lp-features" data-testid="landing-features">
            {FEATURES.map((f, i) => (
              <AnimatedSection key={i} delay={i * 0.05}>
                <div className="lp-feature">
                  <div className="lp-feature-icon" style={{ background: `${f.color}15`, color: f.color }}>
                    {Icons[f.icon]}
                  </div>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* INTEGRATIONS */}
      <section className="lp-section" id="integrations">
        <div className="lp-container">
          <div className="lp-section-title">
            <AnimatedSection>
              <div className="lp-tag" style={{ justifyContent: 'center' }}>Integrações</div>
              <h2 className="lp-h2">Conectado com os <span style={{ color: '#FF6B35' }}>maiores</span></h2>
              <p className="lp-section-sub">Integrações homologadas e testadas em produção. Receba pedidos de todos os canais em um só lugar.</p>
            </AnimatedSection>
          </div>
          <AnimatedSection>
            <div className="lp-integrations" data-testid="landing-integrations">
              {INTEGRATIONS.map((int, i) => (
                <div key={i} className="lp-integration">
                  <IntegrationLogo type={int.logo} size={56} />
                  <span className="lp-integration-name">{int.name}</span>
                  <span className="lp-integration-badge" style={{ background: `${int.color}20`, color: int.color }}>{int.desc}</span>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* WORKFLOW */}
      <section className="lp-section" id="workflow" style={{ background: 'rgba(255,255,255,.01)' }}>
        <div className="lp-container">
          <div className="lp-section-title">
            <AnimatedSection>
              <h2 className="lp-h2">Como <span style={{ color: '#FF6B35' }}>funciona</span></h2>
              <p className="lp-section-sub">Da implantação ao faturamento, em 4 passos simples.</p>
            </AnimatedSection>
          </div>
          <div className="lp-workflow">
            {[
              { num: '01', title: 'Cadastro da Loja', desc: 'Configuramos seus produtos, categorias, horários e formas de pagamento.', color: '#FF6B35' },
              { num: '02', title: 'Conexão dos Canais', desc: 'Ativamos iFood, Keeta, 99Food e WhatsApp. Tudo integrado automaticamente.', color: '#4ECDC4' },
              { num: '03', title: 'Operação em Tempo Real', desc: 'Pedidos chegam no Kanban, vão para a cozinha e saem para entrega.', color: '#F7C948' },
              { num: '04', title: 'Análise & Crescimento', desc: 'Dashboard com métricas, relatórios e insights para escalar seu negócio.', color: '#6C5CE7' },
            ].map((s, i) => (
              <AnimatedSection key={i} delay={i * 0.1}>
                <div className="lp-workflow-step">
                  <div className="lp-workflow-num" style={{ background: `${s.color}15`, color: s.color }}>{s.num}</div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* DIFFERENTIALS */}
      <section className="lp-section">
        <div className="lp-container">
          <div className="lp-section-title">
            <AnimatedSection>
              <h2 className="lp-h2">Por que o <span style={{ color: '#FF6B35' }}>Hit Grill System</span>?</h2>
            </AnimatedSection>
          </div>
          <AnimatedSection>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20, maxWidth: 1000, margin: '0 auto' }}>
              {[
                { title: 'Homologação real com marketplaces', desc: 'Não é gambiarra. Integração oficial testada e aprovada pelo iFood, Keeta e 99Food.' },
                { title: 'IA que entende seus clientes', desc: 'Chatbot treinado com linguagem REAL de clientes brasileiros. Reconhece gírias, abreviações e intenções.' },
                { title: 'Zero dependência de terceiros', desc: 'Sistema próprio, seu servidor, seus dados. Sem mensalidades por pedido ou taxas escondidas.' },
                { title: 'Suporte a operação completa', desc: 'Do PDV fiscal até o motoboy na rua. Um sistema para todas as etapas da operação.' },
              ].map((d, i) => (
                <div key={i} style={{ padding: 28, borderRadius: 16, background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.06)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                    <span style={{ color: '#4ECDC4' }}>{Icons.check}</span>
                    <h3 style={{ fontSize: 16, fontWeight: 700 }}>{d.title}</h3>
                  </div>
                  <p style={{ fontSize: 14, color: '#8B8B9A', lineHeight: 1.6 }}>{d.desc}</p>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta" id="cta">
        <AnimatedSection>
          <h2 className="lp-h2" style={{ marginBottom: 16 }}>Pronto para <span style={{ color: '#FF6B35' }}>transformar</span> seu restaurante?</h2>
          <p className="lp-section-sub" style={{ margin: '0 auto 40px', maxWidth: 500 }}>
            Fale com nossa equipe e descubra como o Hit Grill System pode acelerar sua operação.
          </p>
          <a
            href="https://wa.me/5511999999999?text=Olá! Tenho interesse no Hit Grill System para meu restaurante."
            target="_blank"
            rel="noopener noreferrer"
            className="lp-btn lp-btn-primary"
            style={{ fontSize: 17, padding: '18px 40px' }}
            data-testid="cta-whatsapp-btn"
          >
            Falar pelo WhatsApp {Icons.arrow}
          </a>
        </AnimatedSection>
      </section>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-container">
          <p>Hit Grill System &copy; {new Date().getFullYear()} — Tecnologia para restaurantes</p>
        </div>
      </footer>
    </div>
  );
}
